import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

export const ItemDescription = ({
  description,
}: {
  productTypeName?: string;
  color?: string;
  measurements?: string;
  description: string;
}) => {
  return (
    <FixaText textStyle="Body.M" tagName="p">
      {description}
    </FixaText>
  );
};
